module.exports = __webpack_public_path__ + "img/linkedin-logo.dedb9a80.svg";